export default "/images/vendor/flag-icons/flags/4x3/mn.svg?9116b861b007b313edd4c9d3bad36ae3";